// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes FoI--dropdown--appear{0%{transform:translateY(0px) scaleY(0.9);opacity:0}to{transform:scaleY(1);opacity:1}}@keyframes E_w--dropdown--exit{0%{}to{transform:scaleY(0.8);opacity:0}}.FoI--dropdown--appear,.ang--dropdown--enter{animation:FoI--dropdown--appear 150ms ease-in both}.E_w--dropdown--exit{animation:E_w--dropdown--exit 100ms ease-in both}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appearTimeout": "150ms",
	"enterTimeout": "150ms",
	"exitTimeout": "100ms",
	"appear": "FoI--dropdown--appear",
	"enter": "ang--dropdown--enter",
	"exit": "E_w--dropdown--exit"
};
module.exports = ___CSS_LOADER_EXPORT___;
